import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../common.service';
import { ApiService } from '../api.service';
import { AppShareNewService } from './app-share-new.service';
var AppShareComponent = (function () {
    function AppShareComponent(route, router, commonService, apiService) {
        this.route = route;
        this.router = router;
        this.commonService = commonService;
        this.apiService = apiService;
        this.isShowPage = false; //是否显示页面
        this.assetsRoute = "../../assets"; //静态资源路径
        this.isShowHead = true;
        this.isShowDownloadTip = true;
        this.isShareAfter = false;
        this.buttonTheme = {
            'position': 'inherit',
            'fontSize': 'fontSize15',
            'buttonElem': [
                {
                    'color': 'blue',
                    'text': '保存图片',
                    'className': 'inlineBlockRadiusBtn width-60 height-35 margin-auto'
                }
            ]
        }; //按钮主题
    }
    AppShareComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.appShareService = new AppShareNewService(this.apiService);
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.route.params.subscribe(function (params) {
            _this.learningPathMetaId = params['learningPathMetaId'];
            _this.appShareService.getShareData(_this.learningPathMetaId).then(function (result) {
                _this.shareData = result;
            }).then(function () {
                _this.goldenSentences = _this.shareData.goldenSentences;
                _this.userName = _this.shareData.userName;
                _this.headImgUrl = _this.shareData.headImgUrl ? _this.shareData.headImgUrl : _this.assetsRoute + '/picture/share/default.png';
                _this.overcomeRatio = _this.shareData.overcomeRatio;
                _this.author = _this.shareData.author;
                _this.courseName = _this.commonService.getCourseNameWithLearningPathMetaId(Number(_this.learningPathMetaId));
                _this.isShowPage = true;
            });
        });
    };
    AppShareComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage();
    };
    //关闭分享
    AppShareComponent.prototype.closeSharePage = function () {
        var _this = this;
        this.isShowPage = false;
        setTimeout(function () {
            if (localStorage.getItem('skuId') && !localStorage.getItem('onlyCamp')) {
                _this.router.navigate(['learning-camp', localStorage.getItem('skuId'), localStorage.getItem('campId')]);
            }
            else if (localStorage.getItem('skuId') && localStorage.getItem('onlyCamp')) {
                _this.router.navigate(['learning-camp', localStorage.getItem('skuId'), localStorage.getItem('campId'), -1]);
            }
            else if (!localStorage.getItem('skuId')) {
                var projectId = localStorage.getItem("projectId");
                if (projectId) {
                    _this.router.navigate(['learning-project', projectId]);
                    return;
                }
                _this.router.navigate(['learning-map']);
            }
        }, 1000);
    };
    //H5转png
    AppShareComponent.prototype.savePic = function () {
        var _this = this;
        var dom = document.getElementById('cut-wrap');
        // let width = dom.scrollWidth;
        // let height = dom.scrollHeight;
        var width = dom.offsetWidth;
        var height = dom.offsetHeight;
        var scale = this.setDPR();
        var y = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        var cs = document.createElement('canvas');
        cs.width = width * scale;
        cs.height = height * scale;
        cs.style.width = cs.width + 'px';
        cs.style.height = cs.height + 'px';
        var ctx = cs.getContext('2d');
        ctx.scale(scale, scale);
        $(dom).scrollTop(0, y);
        html2canvas(dom, {
            backgroundColor: '#FFFFFE',
            canvas: cs,
            scale: scale / scale,
            useCORS: true,
            allowTaint: true,
            taintTest: false,
            width: width,
            height: height
        }).then(function (canvas) {
            var context = canvas.getContext('2d');
            context.mozImageSmoothingEnabled = false;
            context.webkitImageSmoothingEnabled = false;
            context.msImageSmoothingEnabled = false;
            context.imageSmoothingEnabled = false;
            $('.canvas-img').attr('src', canvas.toDataURL("image/png", 1.0));
        }).then(function () {
            $('.app-share-wrap').hide();
            $('.canvas-image-wrap').show().addClass('scaleSmall');
            _this.commonService.initPage();
        });
    };
    //根据window.devicePixelRatio获取像素比
    AppShareComponent.prototype.setDPR = function () {
        return window.devicePixelRatio && window.devicePixelRatio > 1 ? window.devicePixelRatio : 1;
    };
    AppShareComponent.prototype.closePic = function () {
        $('.app-share-wrap').show();
        $('.canvas-image-wrap').hide();
        if (localStorage.getItem('skuId') && !localStorage.getItem('onlyCamp')) {
            this.router.navigate(['learning-camp', localStorage.getItem('skuId'), localStorage.getItem('campId')]);
        }
        else if (localStorage.getItem('skuId') && localStorage.getItem('onlyCamp')) {
            this.router.navigate(['learning-camp', localStorage.getItem('skuId'), localStorage.getItem('campId'), -1]);
        }
        else if (!localStorage.getItem('skuId')) {
            var projectId = localStorage.getItem("projectId");
            if (projectId) {
                this.router.navigate(['learning-project', projectId]);
                return;
            }
            this.router.navigate(['learning-map']);
        }
    };
    AppShareComponent.prototype.clickSavePic = function () {
        var _this = this;
        $('.app-share-head').find('.close-btn').hide();
        $('.app-share-btn').hide();
        this.isShareAfter = true;
        setTimeout(function () {
            _this.savePic();
        }, 500);
    };
    //长按开始
    AppShareComponent.prototype.onMouseDown = function (event) {
        this.startTime = new Date().getTime();
    };
    //长按结束
    AppShareComponent.prototype.onMouseUp = function (event) {
        var _this = this;
        this.endTime = new Date().getTime();
        if (this.endTime > this.startTime + 800) {
            $('.close-btn').hide();
            $('.app-share-tip').hide();
            setTimeout(function () {
                _this.savePic();
            }, 100);
        }
        else {
            return;
        }
    };
    return AppShareComponent;
}());
export { AppShareComponent };



// WEBPACK FOOTER //
// ./src/app/app-share/app-share.component.ts.pre-build-optimizer.js